"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[448],{

/***/ 4397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ YouTubeFillIcon; },
/* harmony export */   "IB": function() { return /* binding */ WebsiteFillIcon; },
/* harmony export */   "SA": function() { return /* binding */ TwitterFillIcon; },
/* harmony export */   "Vq": function() { return /* binding */ FacebookIcon; },
/* harmony export */   "Zm": function() { return /* binding */ TwitterIcon; },
/* harmony export */   "cx": function() { return /* binding */ FacebookFillIcon; },
/* harmony export */   "eK": function() { return /* binding */ CopyFillIcon; },
/* harmony export */   "kw": function() { return /* binding */ ShareFillIcon; },
/* harmony export */   "v9": function() { return /* binding */ InstagramFillIcon; }
/* harmony export */ });
/* unused harmony export YouTubeIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);

const TwitterIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717 l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339 l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z"
        })
    });
};
const TwitterFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717 l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339 l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z"
        })
    });
};
const InstagramFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "a",
                width: "24",
                height: "24",
                x: "4",
                y: "4",
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "alpha"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M16 4c-3.26 0-3.667.015-4.947.072-1.278.06-2.148.261-2.913.558a5.876 5.876 0 0 0-2.126 1.384A5.855 5.855 0 0 0 4.63 8.14c-.297.765-.499 1.635-.558 2.913C4.012 12.333 4 12.74 4 16s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913a5.885 5.885 0 0 0 1.384 2.126A5.868 5.868 0 0 0 8.14 27.37c.766.296 1.636.499 2.913.558 1.28.06 1.687.072 4.947.072s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558a5.898 5.898 0 0 0 2.126-1.384 5.86 5.86 0 0 0 1.384-2.126c.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913a5.89 5.89 0 0 0-1.384-2.126A5.847 5.847 0 0 0 23.86 4.63c-.765-.297-1.636-.499-2.913-.558C19.667 4.012 19.26 4 16 4Zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85 0 3.204-.015 3.585-.074 4.85-.061 1.17-.256 1.805-.421 2.227a3.81 3.81 0 0 1-.899 1.382 3.744 3.744 0 0 1-1.38.896c-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421a3.716 3.716 0 0 1-1.379-.899 3.644 3.644 0 0 1-.9-1.38c-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03Zm0 3.678a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 1 0 0-12.324ZM16 20c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm7.846-10.405a1.441 1.441 0 0 1-2.88 0 1.44 1.44 0 0 1 2.88 0Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "url(#b)",
                        d: "M4 16c0-4.678 0-7.017 1.073-8.724a7 7 0 0 1 2.203-2.203C8.983 4 11.322 4 16 4s7.017 0 8.724 1.073a7 7 0 0 1 2.203 2.203C28 8.983 28 11.322 28 16s0 7.017-1.073 8.724a6.999 6.999 0 0 1-2.203 2.203C23.017 28 20.678 28 16 28s-7.017 0-8.724-1.073a7 7 0 0 1-2.203-2.203C4 23.017 4 20.678 4 16Z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "url(#c)",
                        d: "M4 16c0-4.678 0-7.017 1.073-8.724a7 7 0 0 1 2.203-2.203C8.983 4 11.322 4 16 4s7.017 0 8.724 1.073a7 7 0 0 1 2.203 2.203C28 8.983 28 11.322 28 16s0 7.017-1.073 8.724a6.999 6.999 0 0 1-2.203 2.203C23.017 28 20.678 28 16 28s-7.017 0-8.724-1.073a7 7 0 0 1-2.203-2.203C4 23.017 4 20.678 4 16Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                        id: "b",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientTransform: "translate(5.56 27.472) scale(30.48)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: ".09",
                                stopColor: "#FA8F21"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: ".78",
                                stopColor: "#D82D7E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                        id: "c",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientTransform: "translate(20.632 26.704) scale(26.808)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: ".64",
                                stopColor: "#8C3AAA",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8C3AAA"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const FacebookIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
        })
    });
};
const FacebookFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#1877f2",
            d: "M22 13.461h-4v-3.384c0-.93.72-.846 1.6-.846h1.6V5H18c-1.273 0-2.494.535-3.394 1.487a5.23 5.23 0 0 0-1.406 3.59v3.384H10v4.231h3.2V27H18v-9.308h2.4l1.6-4.23Z"
        })
    });
};
const YouTubeIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ _jsx("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
        })
    });
};
const YouTubeFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#ff0000",
            d: "M7.263 23.524a2.536 2.536 0 0 1-1.043-.642 2.678 2.678 0 0 1-.642-1.07c-.736-2.093-.952-10.839.462-12.566a2.682 2.682 0 0 1 1.848-.962c3.792-.426 15.51-.368 16.856.141.378.129.724.345 1.012.632.287.287.508.639.646 1.028.802 2.17.829 10.033-.11 12.113-.249.54-.665.98-1.182 1.245-1.414.735-15.972.721-17.848.085v-.004Zm6.021-4.103 6.797-3.68-6.797-3.701v7.381Z"
        })
    });
};
const WebsiteFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22.49 21.929C22.204 21.049 21.379 20.4 20.4 20.4H19.3V17.1C19.3 16.8083 19.1841 16.5285 18.9778 16.3222C18.7715 16.1159 18.4917 16 18.2 16H11.6V13.8H13.8C14.0917 13.8 14.3715 13.6841 14.5778 13.4778C14.7841 13.2715 14.9 12.9917 14.9 12.7V10.5H17.1C17.6835 10.5 18.2431 10.2682 18.6556 9.85564C19.0682 9.44306 19.3 8.88348 19.3 8.3V7.849C22.523 9.147 24.8 12.304 24.8 16C24.8 18.288 23.92 20.367 22.49 21.929ZM14.9 24.723C10.555 24.184 7.2 20.488 7.2 16C7.2 15.318 7.288 14.658 7.431 14.031L12.7 19.3V20.4C12.7 20.9835 12.9318 21.5431 13.3444 21.9556C13.7569 22.3682 14.3165 22.6 14.9 22.6M16 5C14.5555 5 13.1251 5.28452 11.7905 5.83733C10.4559 6.39013 9.24327 7.20038 8.22183 8.22183C6.15893 10.2847 5 13.0826 5 16C5 18.9174 6.15893 21.7153 8.22183 23.7782C9.24327 24.7996 10.4559 25.6099 11.7905 26.1627C13.1251 26.7155 14.5555 27 16 27C18.9174 27 21.7153 25.8411 23.7782 23.7782C25.8411 21.7153 27 18.9174 27 16C27 14.5555 26.7155 13.1251 26.1627 11.7905C25.6099 10.4559 24.7996 9.24327 23.7782 8.22183C22.7567 7.20038 21.5441 6.39013 20.2095 5.83733C18.8749 5.28452 17.4445 5 16 5V5Z"
        })
    });
};
const CopyFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.2631 2H4.89474C3.85263 2 3 2.81818 3 3.81817V16.5455H4.89474V3.81817H16.2631V2ZM15.3158 5.63635H8.68421C7.64215 5.63635 6.79892 6.45458 6.79892 7.45454L6.78952 20.1818C6.78952 21.1818 7.63264 22 8.67471 22H19.1052C20.1474 22 21 21.1818 21 20.1818V11.0909L15.3158 5.63635ZM8.68421 20.1818V7.45454H14.3684V12H19.1052V20.1818H8.68421Z"
        })
    });
};
const ShareFillIcon = (param)=>{
    let { className , fill ="currentColor"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        role: "img",
        fill: fill,
        className: className,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.6665 8.58317L18.3648 9.88484L16.9073 8.42734V18.6665H15.0923V8.42734L13.6348 9.88484L12.3332 8.58317L15.9998 4.9165L19.6665 8.58317ZM23.3332 13.1665V23.2498C23.3332 24.2582 22.5082 25.0832 21.4998 25.0832H10.4998C10.0136 25.0832 9.54729 24.89 9.20347 24.5462C8.85966 24.2024 8.6665 23.7361 8.6665 23.2498V13.1665C8.6665 12.149 9.48234 11.3332 10.4998 11.3332H13.2498V13.1665H10.4998V23.2498H21.4998V13.1665H18.7498V11.3332H21.4998C21.9861 11.3332 22.4524 11.5263 22.7962 11.8701C23.14 12.214 23.3332 12.6803 23.3332 13.1665Z"
        })
    });
}; // export const LinkedInIcon = ({ className, fill = "currentColor" }: SVGIconProps) => {
 // 	return (
 // 		<svg role="img" fill={fill} className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 // 			<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
 // 		</svg>
 // 	);
 // };
 // export const TelegramIcon = ({ className, fill = "currentColor" }: SVGIconProps) => {
 // 	return (
 // 		<svg role="img" fill={fill} className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 // 			<path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
 // 		</svg>
 // 	);
 // };


/***/ }),

/***/ 9448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cover_Cover; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
// EXTERNAL MODULE: ./hooks/useRender.ts
var useRender = __webpack_require__(3890);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(6631);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(1943);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(6452);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(7729);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(6137);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(3562);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(1526);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(8844);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(9761);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(8652);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(3848);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(509);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-owner.js
function use_owner_n(...e){return (0,react.useMemo)(()=>(0,owner/* getOwnerDocument */.r)(...e),[...e])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(9802);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event-listener.js
function E(n,e,a,t){let i=(0,use_latest_value/* useLatestValue */.E)(a);(0,react.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(3911);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(5463);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-window-event.js
function s(e,r,n){let o=(0,use_latest_value/* useLatestValue */.E)(r);(0,react.useEffect)(()=>{function t(i){o.current(i)}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n])}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction_s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(use_tab_direction_s||{});function use_tab_direction_n(){let e=(0,react.useRef)(0);return s("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var Ce=(f=>(f[f.Open=0]="Open",f[f.Closed=1]="Closed",f))(Ce||{}),Oe=(o=>(o[o.TogglePopover=0]="TogglePopover",o[o.ClosePopover=1]="ClosePopover",o[o.SetButton=2]="SetButton",o[o.SetButtonId=3]="SetButtonId",o[o.SetPanel=4]="SetPanel",o[o.SetPanelId=5]="SetPanelId",o))(Oe||{});let Me={[0]:r=>({...r,popoverState:(0,match/* match */.E)(r.popoverState,{[0]:1,[1]:0})}),[1](r){return r.popoverState===1?r:{...r,popoverState:1}},[2](r,n){return r.button===n.button?r:{...r,button:n.button}},[3](r,n){return r.buttonId===n.buttonId?r:{...r,buttonId:n.buttonId}},[4](r,n){return r.panel===n.panel?r:{...r,panel:n.panel}},[5](r,n){return r.panelId===n.panelId?r:{...r,panelId:n.panelId}}},ne=(0,react.createContext)(null);ne.displayName="PopoverContext";function Z(r){let n=(0,react.useContext)(ne);if(n===null){let f=new Error(`<${r} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(f,Z),f}return n}let re=(0,react.createContext)(null);re.displayName="PopoverAPIContext";function le(r){let n=(0,react.useContext)(re);if(n===null){let f=new Error(`<${r} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(f,le),f}return n}let ae=(0,react.createContext)(null);ae.displayName="PopoverGroupContext";function ve(){return (0,react.useContext)(ae)}let ue=(0,react.createContext)(null);ue.displayName="PopoverPanelContext";function Le(){return (0,react.useContext)(ue)}function Fe(r,n){return (0,match/* match */.E)(n.type,Me,r,n)}let Be="div",he=(0,render/* forwardRefWithAs */.yV)(function(n,f){var O;let I=(0,react.useRef)(null),b=(0,use_sync_refs/* useSyncRefs */.T)(f,(0,use_sync_refs/* optionalRef */.h)(e=>{I.current=e})),S=(0,react.useReducer)(Fe,{popoverState:1,buttons:[],button:null,buttonId:null,panel:null,panelId:null,beforePanelSentinel:(0,react.createRef)(),afterPanelSentinel:(0,react.createRef)()}),[{popoverState:o,button:t,buttonId:P,panel:a,panelId:L,beforePanelSentinel:F,afterPanelSentinel:v},u]=S,s=use_owner_n((O=I.current)!=null?O:t),p=(0,react.useMemo)(()=>{if(!t||!a)return!1;for(let M of document.querySelectorAll("body > *"))if(Number(M==null?void 0:M.contains(t))^Number(M==null?void 0:M.contains(a)))return!0;let e=(0,focus_management/* getFocusableElements */.GO)(),l=e.indexOf(t),d=(l+e.length-1)%e.length,E=(l+1)%e.length,D=e[d],Y=e[E];return!a.contains(D)&&!a.contains(Y)},[t,a]),c=(0,use_latest_value/* useLatestValue */.E)(P),T=(0,use_latest_value/* useLatestValue */.E)(L),g=(0,react.useMemo)(()=>({buttonId:c,panelId:T,close:()=>u({type:1})}),[c,T,u]),A=ve(),C=A==null?void 0:A.registerPopover,k=(0,use_event/* useEvent */.z)(()=>{var e;return(e=A==null?void 0:A.isFocusWithinPopoverGroup())!=null?e:(s==null?void 0:s.activeElement)&&((t==null?void 0:t.contains(s.activeElement))||(a==null?void 0:a.contains(s.activeElement)))});(0,react.useEffect)(()=>C==null?void 0:C(g),[C,g]),E(s==null?void 0:s.defaultView,"focus",e=>{var l,d,E,D;o===0&&(k()||!t||!a||e.target!==window&&((d=(l=F.current)==null?void 0:l.contains)!=null&&d.call(l,e.target)||(D=(E=v.current)==null?void 0:E.contains)!=null&&D.call(E,e.target)||u({type:1})))},!0),(0,use_outside_click/* useOutsideClick */.O)([t,a],(e,l)=>{u({type:1}),(0,focus_management/* isFocusableElement */.sP)(l,focus_management/* FocusableMode.Loose */.tJ.Loose)||(e.preventDefault(),t==null||t.focus())},o===0);let B=(0,use_event/* useEvent */.z)(e=>{u({type:1});let l=(()=>e?e instanceof HTMLElement?e:"current"in e&&e.current instanceof HTMLElement?e.current:t:t)();l==null||l.focus()}),W=(0,react.useMemo)(()=>({close:B,isPortalled:p}),[B,p]),i=(0,react.useMemo)(()=>({open:o===0,close:B}),[o,B]),m=n,R={ref:b};return react.createElement(ne.Provider,{value:S},react.createElement(re.Provider,{value:W},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(o,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},(0,render/* render */.sY)({ourProps:R,theirProps:m,slot:i,defaultTag:Be,name:"Popover"}))))}),xe="button",De=(0,render/* forwardRefWithAs */.yV)(function(n,f){let I=(0,use_id/* useId */.M)(),{id:b=`headlessui-popover-button-${I}`,...S}=n,[o,t]=Z("Popover.Button"),{isPortalled:P}=le("Popover.Button"),a=(0,react.useRef)(null),L=`headlessui-focus-sentinel-${(0,use_id/* useId */.M)()}`,F=ve(),v=F==null?void 0:F.closeOthers,u=Le(),s=u===null?!1:u===o.panelId;(0,react.useEffect)(()=>{if(!s)return t({type:3,buttonId:b}),()=>{t({type:3,buttonId:null})}},[b,t]);let p=(0,use_sync_refs/* useSyncRefs */.T)(a,f,s?null:e=>{if(e)o.buttons.push(b);else{let l=o.buttons.indexOf(b);l!==-1&&o.buttons.splice(l,1)}o.buttons.length>1&&console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."),e&&t({type:2,button:e})}),c=(0,use_sync_refs/* useSyncRefs */.T)(a,f),T=use_owner_n(a),g=(0,use_event/* useEvent */.z)(e=>{var l,d,E;if(s){if(o.popoverState===1)return;switch(e.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:e.preventDefault(),(d=(l=e.target).click)==null||d.call(l),t({type:1}),(E=o.button)==null||E.focus();break}}else switch(e.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:e.preventDefault(),e.stopPropagation(),o.popoverState===1&&(v==null||v(o.buttonId)),t({type:0});break;case keyboard/* Keys.Escape */.R.Escape:if(o.popoverState!==0)return v==null?void 0:v(o.buttonId);if(!a.current||(T==null?void 0:T.activeElement)&&!a.current.contains(T.activeElement))return;e.preventDefault(),e.stopPropagation(),t({type:1});break}}),A=(0,use_event/* useEvent */.z)(e=>{s||e.key===keyboard/* Keys.Space */.R.Space&&e.preventDefault()}),C=(0,use_event/* useEvent */.z)(e=>{var l,d;(0,bugs/* isDisabledReactIssue7711 */.P)(e.currentTarget)||n.disabled||(s?(t({type:1}),(l=o.button)==null||l.focus()):(e.preventDefault(),e.stopPropagation(),o.popoverState===1&&(v==null||v(o.buttonId)),t({type:0}),(d=o.button)==null||d.focus()))}),k=(0,use_event/* useEvent */.z)(e=>{e.preventDefault(),e.stopPropagation()}),B=o.popoverState===0,W=(0,react.useMemo)(()=>({open:B}),[B]),i=(0,use_resolve_button_type/* useResolveButtonType */.f)(n,a),m=s?{ref:c,type:i,onKeyDown:g,onClick:C}:{ref:p,id:o.buttonId,type:i,"aria-expanded":n.disabled?void 0:o.popoverState===0,"aria-controls":o.panel?o.panelId:void 0,onKeyDown:g,onKeyUp:A,onClick:C,onMouseDown:k},R=use_tab_direction_n(),O=(0,use_event/* useEvent */.z)(()=>{let e=o.panel;if(!e)return;function l(){(0,match/* match */.E)(R.current,{[use_tab_direction_s.Forwards]:()=>(0,focus_management/* focusIn */.jA)(e,focus_management/* Focus.First */.TO.First),[use_tab_direction_s.Backwards]:()=>(0,focus_management/* focusIn */.jA)(e,focus_management/* Focus.Last */.TO.Last)})}l()});return react.createElement(react.Fragment,null,(0,render/* render */.sY)({ourProps:m,theirProps:S,slot:W,defaultTag:xe,name:"Popover.Button"}),B&&!s&&P&&react.createElement(internal_hidden/* Hidden */._,{id:L,features:internal_hidden/* Features.Focusable */.A.Focusable,as:"button",type:"button",onFocus:O}))}),He="div",ke=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,Ge=(0,render/* forwardRefWithAs */.yV)(function(n,f){let I=(0,use_id/* useId */.M)(),{id:b=`headlessui-popover-overlay-${I}`,...S}=n,[{popoverState:o},t]=Z("Popover.Overlay"),P=(0,use_sync_refs/* useSyncRefs */.T)(f),a=(0,open_closed/* useOpenClosed */.oJ)(),L=(()=>a!==null?a===open_closed/* State.Open */.ZM.Open:o===0)(),F=(0,use_event/* useEvent */.z)(s=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(s.currentTarget))return s.preventDefault();t({type:1})}),v=(0,react.useMemo)(()=>({open:o===0}),[o]);return (0,render/* render */.sY)({ourProps:{ref:P,id:b,"aria-hidden":!0,onClick:F},theirProps:S,slot:v,defaultTag:He,features:ke,visible:L,name:"Popover.Overlay"})}),we="div",_e=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,Ne=(0,render/* forwardRefWithAs */.yV)(function(n,f){let I=(0,use_id/* useId */.M)(),{id:b=`headlessui-popover-panel-${I}`,focus:S=!1,...o}=n,[t,P]=Z("Popover.Panel"),{close:a,isPortalled:L}=le("Popover.Panel"),F=`headlessui-focus-sentinel-before-${(0,use_id/* useId */.M)()}`,v=`headlessui-focus-sentinel-after-${(0,use_id/* useId */.M)()}`,u=(0,react.useRef)(null),s=(0,use_sync_refs/* useSyncRefs */.T)(u,f,i=>{P({type:4,panel:i})}),p=use_owner_n(u);(0,react.useEffect)(()=>(P({type:5,panelId:b}),()=>{P({type:5,panelId:null})}),[b,P]);let c=(0,open_closed/* useOpenClosed */.oJ)(),T=(()=>c!==null?c===open_closed/* State.Open */.ZM.Open:t.popoverState===0)(),g=(0,use_event/* useEvent */.z)(i=>{var m;switch(i.key){case keyboard/* Keys.Escape */.R.Escape:if(t.popoverState!==0||!u.current||(p==null?void 0:p.activeElement)&&!u.current.contains(p.activeElement))return;i.preventDefault(),i.stopPropagation(),P({type:1}),(m=t.button)==null||m.focus();break}});(0,react.useEffect)(()=>{var i;n.static||t.popoverState===1&&((i=n.unmount)!=null?i:!0)&&P({type:4,panel:null})},[t.popoverState,n.unmount,n.static,P]),(0,react.useEffect)(()=>{if(!S||t.popoverState!==0||!u.current)return;let i=p==null?void 0:p.activeElement;u.current.contains(i)||(0,focus_management/* focusIn */.jA)(u.current,focus_management/* Focus.First */.TO.First)},[S,u,t.popoverState]);let A=(0,react.useMemo)(()=>({open:t.popoverState===0,close:a}),[t,a]),C={ref:s,id:t.panelId,onKeyDown:g,onBlur:S&&t.popoverState===0?i=>{var R,O,e,l,d;let m=i.relatedTarget;!m||!u.current||(R=u.current)!=null&&R.contains(m)||(P({type:1}),(((e=(O=t.beforePanelSentinel.current)==null?void 0:O.contains)==null?void 0:e.call(O,m))||((d=(l=t.afterPanelSentinel.current)==null?void 0:l.contains)==null?void 0:d.call(l,m)))&&m.focus({preventScroll:!0}))}:void 0,tabIndex:-1},k=use_tab_direction_n(),B=(0,use_event/* useEvent */.z)(()=>{let i=u.current;if(!i)return;function m(){(0,match/* match */.E)(k.current,{[use_tab_direction_s.Forwards]:()=>{(0,focus_management/* focusIn */.jA)(i,focus_management/* Focus.First */.TO.First)},[use_tab_direction_s.Backwards]:()=>{var R;(R=t.button)==null||R.focus({preventScroll:!0})}})}m()}),W=(0,use_event/* useEvent */.z)(()=>{let i=u.current;if(!i)return;function m(){(0,match/* match */.E)(k.current,{[use_tab_direction_s.Forwards]:()=>{var E,D,Y;if(!t.button)return;let R=(0,focus_management/* getFocusableElements */.GO)(),O=R.indexOf(t.button),e=R.slice(0,O+1),d=[...R.slice(O+1),...e];for(let M of d.slice())if(((D=(E=M==null?void 0:M.id)==null?void 0:E.startsWith)==null?void 0:D.call(E,"headlessui-focus-sentinel-"))||((Y=t.panel)==null?void 0:Y.contains(M))){let pe=d.indexOf(M);pe!==-1&&d.splice(pe,1)}(0,focus_management/* focusIn */.jA)(d,focus_management/* Focus.First */.TO.First,!1)},[use_tab_direction_s.Backwards]:()=>(0,focus_management/* focusIn */.jA)(i,focus_management/* Focus.Last */.TO.Last)})}m()});return react.createElement(ue.Provider,{value:t.panelId},T&&L&&react.createElement(internal_hidden/* Hidden */._,{id:F,ref:t.beforePanelSentinel,features:internal_hidden/* Features.Focusable */.A.Focusable,as:"button",type:"button",onFocus:B}),(0,render/* render */.sY)({ourProps:C,theirProps:o,slot:A,defaultTag:we,features:_e,visible:T,name:"Popover.Panel"}),T&&L&&react.createElement(internal_hidden/* Hidden */._,{id:v,ref:t.afterPanelSentinel,features:internal_hidden/* Features.Focusable */.A.Focusable,as:"button",type:"button",onFocus:W}))}),Ke="div",Ue=(0,render/* forwardRefWithAs */.yV)(function(n,f){let I=(0,react.useRef)(null),b=(0,use_sync_refs/* useSyncRefs */.T)(I,f),[S,o]=(0,react.useState)([]),t=(0,use_event/* useEvent */.z)(p=>{o(c=>{let T=c.indexOf(p);if(T!==-1){let g=c.slice();return g.splice(T,1),g}return c})}),P=(0,use_event/* useEvent */.z)(p=>(o(c=>[...c,p]),()=>t(p))),a=(0,use_event/* useEvent */.z)(()=>{var T;let p=(0,owner/* getOwnerDocument */.r)(I);if(!p)return!1;let c=p.activeElement;return(T=I.current)!=null&&T.contains(c)?!0:S.some(g=>{var A,C;return((A=p.getElementById(g.buttonId.current))==null?void 0:A.contains(c))||((C=p.getElementById(g.panelId.current))==null?void 0:C.contains(c))})}),L=(0,use_event/* useEvent */.z)(p=>{for(let c of S)c.buttonId.current!==p&&c.close()}),F=(0,react.useMemo)(()=>({registerPopover:P,unregisterPopover:t,isFocusWithinPopoverGroup:a,closeOthers:L}),[P,t,a,L]),v=(0,react.useMemo)(()=>({}),[]),u=n,s={ref:b};return react.createElement(ae.Provider,{value:F},(0,render/* render */.sY)({ourProps:s,theirProps:u,slot:v,defaultTag:Ke,name:"Popover.Group"}))}),St=Object.assign(he,{Button:De,Overlay:Ge,Panel:Ne,Group:Ue});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(7690);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7280);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Icons/Social.icons.tsx
var Social_icons = __webpack_require__(4397);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./hooks/useClipboard.ts

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0,react.useState)(null);
    const copy = async (text)=>{
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    };
    return [
        copiedText,
        copy
    ];
}
/* harmony default export */ var useClipboard = (useCopyToClipboard);

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(8227);
;// CONCATENATED MODULE: ./components/Socials/CopyClipboard.tsx







const CopyClipboard = (param)=>{
    let { text , closePopover  } = param;
    const [_, copy] = useClipboard();
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const addToast = (0,react.useCallback)(()=>{
        copy(text);
        closePopover();
        dist/* toast.custom */.Am.custom((h)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "toast-undo",
                className: "flex items-center p-4 w-full max-w-xs text-gray-700 bg-white shadow-xl rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5",
                role: "alert",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdCheckCircle */.ZSR, {
                        className: "w-5 h-5 text-primary-500 mr-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm font-normal",
                        children: t("social.copy_clipboard_done")
                    })
                ]
            }), {
            id: "clipboard"
        });
    }, [
        copy,
        t,
        text,
        closePopover
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        className: "flex w-full items-center text-left rounded-lg px-4 py-3 transition duration-150 ease-in-out hover:bg-primary-50 focus:outline-none focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
        "aria-label": "Copy to Clipboard",
        onClick: addToast,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shrink-0 text-zinc-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_icons/* CopyFillIcon */.eK, {
                    className: "w-4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm font-medium text-zinc-800",
                    children: t("social.copy_clipboard")
                })
            })
        ]
    });
};
/* harmony default export */ var Socials_CopyClipboard = (CopyClipboard);

// EXTERNAL MODULE: ./hooks/useMobile.ts
var useMobile = __webpack_require__(3073);
;// CONCATENATED MODULE: ./components/Socials/Share.tsx









function SharePopover(param) {
    let { businessName  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const isMobile = (0,useMobile/* default */.Z)();
    const [url, setUrl] = (0,react.useState)("");
    const mobileShare = (0,react.useCallback)(()=>{
        if (navigator.share) {
            navigator.share({
                url,
                text: businessName,
                title: businessName
            }).then(()=>console.log("Share was successful.")).catch((error)=>console.log("Sharing failed", error));
        }
    }, [
        url,
        businessName
    ]);
    (0,react.useEffect)(()=>{
        setUrl(window.location.href.split("?")[0]);
    }, []);
    const links = (0,react.useMemo)(()=>[
            {
                name: t("social.share_tweet"),
                href: (0,utils/* generateSocialShare */.Ee)({
                    type: "twitter",
                    businessName,
                    url
                }),
                icon: Social_icons/* TwitterIcon */.Zm
            },
            {
                name: t("social.share_facebook"),
                href: (0,utils/* generateSocialShare */.Ee)({
                    type: "facebook",
                    url
                }),
                icon: Social_icons/* FacebookIcon */.Vq
            }
        ], [
        t,
        businessName,
        url
    ]);
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: mobileShare,
            "aria-label": "Share Button",
            className: "block p-1 transition-colors bg-primary-300 rounded-lg hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-white/50",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_icons/* ShareFillIcon */.kw, {
                className: "rounded-lg text-white h-10 md:h-9"
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-sm",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(St, {
                className: "relative",
                children: (param)=>/*#__PURE__*/ {
                    let { open , close  } = param;
                    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(St.Button, {
                                "aria-label": "Share Button",
                                className: classnames_default()({
                                    "bg-primary-500": open
                                }, "focus:outline-none focus:ring-2 focus:ring-white/50", "block p-1 transition-colors bg-primary-300 rounded-lg hover:bg-primary-500"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social_icons/* ShareFillIcon */.kw, {
                                    className: "rounded-lg text-white h-10 md:h-9"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                as: react.Fragment,
                                enter: "transition ease-out duration-200",
                                enterFrom: "opacity-0 translate-y-1",
                                enterTo: "opacity-100 translate-y-0",
                                leave: "transition ease-in duration-150",
                                leaveFrom: "opacity-100 translate-y-0",
                                leaveTo: "opacity-0 translate-y-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(St.Panel, {
                                    focus: false,
                                    className: classnames_default()("absolute right-0 z-10 mt-3 w-screen max-w-[16rem]", "xl:-translate-x-1/2 xl:transform xl:right-auto xl:left-1/2"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "bg-white p-2",
                                            children: [
                                                links.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: item.href,
                                                        target: "_blank",
                                                        className: "flex items-center rounded-lg px-4 py-3 transition duration-150 ease-in-out hover:bg-primary-50 focus:outline-none focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-opacity-50 mb-2",
                                                        rel: "noreferrer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "shrink-0 text-zinc-500",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                                    className: "h-4",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "ml-4",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-sm font-medium text-zinc-800",
                                                                    children: item.name
                                                                })
                                                            })
                                                        ]
                                                    }, item.name)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Socials_CopyClipboard, {
                                                    closePopover: close,
                                                    text: url
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    });
                }
            })
        });
    }
}
/* harmony default export */ var Share = (/*#__PURE__*/(0,react.memo)(SharePopover));

;// CONCATENATED MODULE: ./containers/Cover/Carousel.tsx





function Carousel(param) {
    let { businessName , covers  } = param;
    const [counter, setCounter] = (0,react.useState)(1);
    const [pause, setPause] = (0,react.useState)(false);
    const length = (covers === null || covers === void 0 ? void 0 : covers.length) || 0;
    const handleNext = (0,react.useCallback)(()=>{
        if (counter !== length) {
            setCounter(counter + 1);
        } else {
            setCounter(1);
        }
    }, [
        counter,
        length
    ]);
    const handlePrevious = (0,react.useCallback)(()=>{
        if (counter > 1) {
            setCounter(counter - 1);
        } else {
            setCounter(length);
        }
    }, [
        counter,
        length
    ]);
    (0,react.useEffect)(()=>{
        let interval = setInterval(()=>{
            if (!pause) {
                handleNext();
            } else {
                clearInterval(interval);
            }
        }, 5000);
        return ()=>clearInterval(interval);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: handleNext,
                        className: "group-hover:opacity-100 md:opacity-0 opacity-100 absolute text-white rounded-full p-3 md:p-2 top-1/2 left-3 md:left-8 -translate-y-1/2 bg-[#000]/40 hover:bg-[#000] transition-all z-30 cursor-pointer appearance-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowLeft */.sG8, {
                            className: "w-5 h-5"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: handlePrevious,
                        className: "group-hover:opacity-100 md:opacity-0 opacity-100 absolute text-white rounded-full p-3 md:p-2 top-1/2 right-3 md:right-8 -translate-y-1/2 bg-[#000]/40 hover:bg-[#000] transition-all z-30 cursor-pointer appearance-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowRight */.AeI, {
                            className: "w-5 h-5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-[300px] lg:h-auto lg:aspect-[4] w-full bg-primary-500 overflow-hidden md:rounded-xl",
                children: covers === null || covers === void 0 ? void 0 : covers.map((item, i)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("absolute inset-0 transition ease-out duration-700", {
                            "opacity-100": counter - 1 === i,
                            "opacity-0": counter - 1 !== i
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            fill: true,
                            className: "object-cover object-center select-none",
                            src: item === null || item === void 0 ? void 0 : item.url,
                            alt: businessName,
                            sizes: "(max-width: 768px) 50vw, (max-width: 1200px) 50vw, 33vw",
                            priority: i === 0
                        })
                    }, i);
                })
            })
        ]
    });
}
/* harmony default export */ var Cover_Carousel = (/*#__PURE__*/(0,react.memo)(Carousel));

;// CONCATENATED MODULE: ./containers/Cover/Cover.tsx








function Cover(param) {
    let { businessName , businessLogo , rate , covers  } = param;
    const { score , count  } = rate || {};
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const isReviewRenderable = (0,useRender/* useCanRender */.f)("review");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover_Carousel, {
                businessName: businessName,
                covers: covers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute z-30 top-4 right-4 md:top-auto md:bottom-8 md:right-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Share, {
                    businessName: businessName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute flex items-center z-20 bottom-4 left-4 md:bottom-8 md:left-8 text-white space-x-4",
                children: [
                    (businessLogo === null || businessLogo === void 0 ? void 0 : businessLogo.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-14 aspect-square md:w-16 lg:w-24",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "w-full h-full object-contain rounded-full",
                            src: businessLogo === null || businessLogo === void 0 ? void 0 : businessLogo.url,
                            width: 64,
                            height: 64,
                            priority: true,
                            alt: (businessLogo === null || businessLogo === void 0 ? void 0 : businessLogo.alt) || businessName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-flex-column space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-xl font-normal md:text-3xl lg:text-4xl",
                                children: businessName
                            }),
                            isReviewRenderable && (count && count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center space-x-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            score,
                                            " / 5"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdStar */.MVI, {
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    count,
                                                    " ",
                                                    t("navigation.review")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("global.noreview")
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "absolute bottom-0 left-0 right-0 gradient-placeholder z-10 h-full md:rounded-b-xl"
            })
        ]
    });
}
/* harmony default export */ var Cover_Cover = (/*#__PURE__*/(0,react.memo)(Cover));


/***/ }),

/***/ 3073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1776);

const useMobile = ()=>{
    const [mobile, setMobile] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const userAgent = !!navigator.userAgent.match(/android|webos|ip(hone|ad|od)|opera (mini|mobi|tablet)|iemobile|windows.+(phone|touch)|mobile|fennec|kindle (Fire)|Silk|maemo|blackberry|playbook|bb10\; (touch|kbd)|Symbian(OS)|Ubuntu Touch/i);
        setMobile(userAgent);
    }, []);
    return mobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobile);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; },
/* harmony export */   "vY": function() { return /* binding */ sortListByAnotherList; }
/* harmony export */ });
/* unused harmony export isProd */
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(194);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3488);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6031);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(394);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4035);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(776);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7457);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4237);




const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    const link = query_string__WEBPACK_IMPORTED_MODULE_0__/* ["default"].stringifyUrl */ .Z.stringifyUrl({
        url: "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier),
        query: {
            lng: locale,
            locations: type === "location" ? id : undefined,
            op: type === "provider" ? "~".concat(id) : type === "service" ? "".concat(id, "~") : undefined
        }
    });
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>{
    return "/b/".concat(path);
};
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    return truncateString(label, limit);
};
function sortListByAnotherList(unsortedList, sortedList) {
    let key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "id";
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(unsortedList) || (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(sortedList)) {
        return unsortedList;
    }
    const indexedUnsortedList = (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(unsortedList, key);
    if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(sortedList[0])) {
        const diff = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(unsortedList, (item)=>item && item[key]), sortedList);
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            ...sortedList,
            ...diff
        ], (key)=>indexedUnsortedList[key]));
    } else {
        const diff1 = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(unsortedList, sortedList, key);
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            ...sortedList,
            ...diff1
        ], (item)=>indexedUnsortedList[item[key]]));
    }
}



/***/ }),

/***/ 3848:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ L; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(8844);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(9802);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-document-event.js
function d(e,r,n){let o=(0,use_latest_value/* useLatestValue */.E)(r);(0,react.useEffect)(()=>{function t(u){o.current(u)}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n)},[e,n])}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js
function L(m,E,c=!0){let i=(0,react.useRef)(!1);(0,react.useEffect)(()=>{requestAnimationFrame(()=>{i.current=c})},[c]);function f(e,o){if(!i.current||e.defaultPrevented)return;let l=function r(t){return typeof t=="function"?r(t()):Array.isArray(t)||t instanceof Set?t:[t]}(m),n=o(e);if(n!==null&&!!n.getRootNode().contains(n)){for(let r of l){if(r===null)continue;let t=r instanceof HTMLElement?r:r.current;if(t!=null&&t.contains(n)||e.composed&&e.composedPath().includes(t))return}return!(0,focus_management/* isFocusableElement */.sP)(n,focus_management/* FocusableMode.Loose */.tJ.Loose)&&n.tabIndex!==-1&&e.preventDefault(),E(e,n)}}let u=(0,react.useRef)(null);d("mousedown",e=>{var o,l;i.current&&(u.current=((l=(o=e.composedPath)==null?void 0:o.call(e))==null?void 0:l[0])||e.target)},!0),d("click",e=>{!u.current||(f(e,()=>u.current),u.current=null)},!0),d("blur",e=>f(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0)}


/***/ }),

/***/ 3911:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ s; },
/* harmony export */   "_": function() { return /* binding */ h; }
/* harmony export */ });
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6452);
let a="div";var s=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(s||{});let h=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .forwardRefWithAs */ .yV)(function(t,o){let{features:e=1,...r}=t,d={ref:o,"aria-hidden":(e&2)===2?!0:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(e&4)===4&&(e&2)!==2&&{display:"none"}}};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .render */ .sY)({ourProps:d,theirProps:r,slot:{},defaultTag:a,name:"Hidden"})});


/***/ }),

/***/ 8844:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GO": function() { return /* binding */ d; },
/* harmony export */   "TO": function() { return /* binding */ T; },
/* harmony export */   "jA": function() { return /* binding */ O; },
/* harmony export */   "sP": function() { return /* binding */ F; },
/* harmony export */   "tJ": function() { return /* binding */ N; },
/* harmony export */   "z2": function() { return /* binding */ S; }
/* harmony export */ });
/* unused harmony exports FocusResult, focusElement, focusFrom, restoreFocusIfNecessary */
/* harmony import */ var _match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1943);
/* harmony import */ var _owner_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(509);
let m=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var T=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(T||{}),M=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(M||{}),b=(r=>(r[r.Previous=-1]="Previous",r[r.Next=1]="Next",r))(b||{});function d(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(m))}var N=(r=>(r[r.Strict=0]="Strict",r[r.Loose=1]="Loose",r))(N||{});function F(e,t=0){var r;return e===((r=(0,_owner_js__WEBPACK_IMPORTED_MODULE_0__/* .getOwnerDocument */ .r)(e))==null?void 0:r.body)?!1:(0,_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(t,{[0](){return e.matches(m)},[1](){let l=e;for(;l!==null;){if(l.matches(m))return!0;l=l.parentElement}return!1}})}function I(e){let t=c(e);p().nextFrame(()=>{t&&!F(t.activeElement,0)&&h(e)})}function h(e){e==null||e.focus({preventScroll:!0})}let w=["textarea","input"].join(",");function H(e){var t,r;return(r=(t=e==null?void 0:e.matches)==null?void 0:t.call(e,w))!=null?r:!1}function S(e,t=r=>r){return e.slice().sort((r,l)=>{let o=t(r),s=t(l);if(o===null||s===null)return 0;let n=o.compareDocumentPosition(s);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function D(e,t){return O(d(),t,!0,e)}function O(e,t,r=!0,l=null){let o=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,s=Array.isArray(e)?r?S(e):e:d(e);l=l!=null?l:o.activeElement;let n=(()=>{if(t&5)return 1;if(t&10)return-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),E=(()=>{if(t&1)return 0;if(t&2)return Math.max(0,s.indexOf(l))-1;if(t&4)return Math.max(0,s.indexOf(l))+1;if(t&8)return s.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),x=t&32?{preventScroll:!0}:{},f=0,i=s.length,u;do{if(f>=i||f+i<=0)return 0;let a=E+f;if(t&16)a=(a+i)%i;else{if(a<0)return 3;if(a>=i)return 1}u=s[a],u==null||u.focus(x),f+=n}while(u!==o.activeElement);return t&6&&H(u)&&u.select(),u.hasAttribute("tabindex")||u.setAttribute("tabindex","0"),2}


/***/ })

}]);